import { createSlice } from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
	name: 'auth/session',
	initialState: {
        token: '',
        lastCheck: null,
        signedIn: false,
        renewPassword: false,
        passwordRegex: null,
        lastNPassword: null,
    },
	reducers: {
        onSignInSuccess: (state, action) => {
            state.signedIn = true
            state.token = action.payload
        },
        onSignOutSuccess: (state) => {
            state.signedIn = false
            state.token = ''
            state.renewPassword = false
            state.passwordRegex = null
            state.lastNPassword = null
        },
        setToken: (state, action) =>  {
            state.token = action.payload
        },
        setRenewPassword: (state, action) => {
            state.renewPassword = action.payload.renewPassword
            state.passwordRegex = action.payload.regex || null
            state.lastNPassword = action.payload.lastNPassword || null
        },
        clearRenewPassword: (state) => {
            state.renewPassword = false
            state.passwordRegex = null
            state.lastNPassword = null
        }
	},
})

export const {
    onSignInSuccess,
    onSignOutSuccess,
    setToken,
    setRenewPassword,
    clearRenewPassword
} = sessionSlice.actions

export default sessionSlice.reducer